import { isArray, isObject } from "sharekit";
export const combineToken = (a, b) => (a ? a + (b ? " " + b : "") : b) || "";
/**
 * tokenList combines tokens into a single string,
 * it does not trim blanks and remove duplicates.
 *
 * To set element attributes, use {@link attr}.
 *
 * Useful for classList, part, etc.
 *
 * @param args Tokens to combine.
 * @returns Combined string.
 */
export const tokenList = (...args) => args.reduce((acc, cur) => {
    if (!cur) {
        return acc;
    }
    if (isArray(cur)) {
        return combineToken(acc, tokenList(...cur));
    }
    if (isObject(cur)) {
        for (const key in cur) {
            if (cur[key]) {
                acc = combineToken(acc, key);
            }
        }
        return acc;
    }
    return combineToken(acc, cur);
}, "");
//# sourceMappingURL=token-list.js.map